import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FIELDS, MODE, TOAST_MESSAGES } from "../../../constants/SiteConstants";
import Loader from "../../../components/commonComponent/Loader";
import useLoader from "../../../hooks/useLoader";
import AttributeForm from "./AttributeForm";

const API_URL = process.env.REACT_APP_API_URL;

const AddAttribute = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [imagePreview, setImagePreview] = useState([]);
  const { loading, showLoader, hideLoader } = useLoader();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        showLoader();
        const response = await axios.get(`${API_URL}/productcategory/getAllproductcategories`);
        setCategories(response.data.data);
      } catch (error) {
        toast.error(TOAST_MESSAGES.ERROR_FETCHING_CATEGORIES, {
          autoClose: 1000,
        });
      } finally {
        hideLoader();
      }
    };

    fetchCategories();
  }, []);

  const fields = [
    {
      label: FIELDS.NAME,
      name: "name",
      placeholder: "Enter name",
      required: true,
    },
    {
      label: "Category",
      name: "categoryId",
      required: true,
      type: "select",
      options: [
        { value: "", name: "Select Category" },
        ...(Array.isArray(categories)
          ? categories.map((category) => ({
              value: category._id, 
              name: category.name,
            }))
          : []),
      ],
    },
    {
      label: FIELDS.TYPE,
      name: "type",
      required: true,
      type: "select",
      options: [
        { value: MODE.TEXT, name: "Text" },
        { value: MODE.DROPDOWN, name: "Dropdown" },
      ],
    }, 
    {
      name: "status",
      type: "switch",
    },
  ];

  const addAttribute = async (formData) => {
    try {
      const response = await axios.post(
        `${API_URL}/attribute/addAttribute`,
        formData
      );
      return response.data;
    } catch (error) {
      throw new Error("Error adding data");
    }
  };

  const handleSubmit = async (formData) => {
    try {
      await addAttribute(formData);
      toast.success(TOAST_MESSAGES.DATA_SAVED, { autoClose: 1000 });
      navigate("/attribute");
    } catch (error) {
      toast.error(TOAST_MESSAGES.ERROR_ADD, { autoClose: 1000 });
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImagePreview(files.map((file) => URL.createObjectURL(file)));
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add Attribute
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/attribute")}
        >
          &times;
        </button>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <AttributeForm
          mode={MODE.ADD}
          onSubmit={handleSubmit}
          fields={fields}
          handleImageChange={handleImageChange}
          imagePreview={imagePreview}
        />
      )}
    </div>
  );
};

export default AddAttribute;
